import useABTestValue from '@hooks/useABTestValue'

export type UseShowBundling = () => boolean

const useShowBundling: UseShowBundling = () =>
  useABTestValue('showBundling') === 'show'

export default useShowBundling
